import { render, staticRenderFns } from "./formBatchNumber.vue?vue&type=template&id=89f16bce&scoped=true&"
import script from "./formBatchNumber.vue?vue&type=script&lang=js&"
export * from "./formBatchNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f16bce",
  null
  
)

export default component.exports